import React, { useState, useRef, useEffect } from 'react';
import './StaffCarousel.css';

// Import local staff images
import mohammedChaib from './images/mohammed_chaib.jpg';
import BoumakhRayane from './images/BoumakhRayane.jpg';
import SeridiHana from './images/SeridiHana.jpg';
import HaoualaManal from './images/HaoualaManal.jpg';
import AlaKERBOUCHE from './images/AlaKERBOUCHE.jpg';
import belbakhouchelamis from './images/belbakhouchelamis.jpg';
import fatinehadilbouacha from './images/fatinehadilbouacha.jpg';
import AmelKhalfallah from './images/AmelKhalfallah.jpg';
import bouchemalSouha from './images/bouchemalSouha.jpg';

const StaffCarousel = () => {
  const gradients = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
  ];

  const staffMembers = [
    {
      id: 1,
      name: "Nafaa Nabil BRAHMIA",
      role: "Robotics & AUTOMATION Specialist",
      image: mohammedChaib,
      description: "Former NASA engineer with expertise in robotics and artificial intelligence. Loves inspiring young minds to build the future.",
      icon: "fas fa-robot",
      gradient: gradients[0]
    },
    {
      id: 2,
      name: "Amira BRAHMIA",
      role: "Proffessor of Human Sciences ",
      image: mohammedChaib,
      description: "Full-stack developer turned educator. Specializes in Python, JavaScript, and making coding fun for beginners of all ages.",
      icon: "fas fa-code",
      gradient: gradients[1]
    },
    {
      id: 3,
      name: "Mohammed CHAIB",
      role: "Head of Computer Science Department",
      image: mohammedChaib,
      description:
        "AI Engineer and Robotics Coach passionate about building intelligent systems that bridge creativity and technology. Experienced in IoT, automation, and deep learning, empowering students to turn innovation into reality.",
      icon: "fas fa-brain",
      gradient: gradients[2],
    },
    {
      id: 4,
      name: "Rayane BOUMAKH",
      role: "EFL Teacher & Social Media Manager",
      image: BoumakhRayane,
      description: "A passionate EFL teacher, social media manager, and photography enthusiast who blends creativity with communication to inspire, connect, and create meaningful learning experiences.",
      icon: "fas fa-microscope",
      gradient: gradients[3]
    },
    {
      id: 5,
      name: "Hana SERIDI",
      role: "Enseignante de français",
      image: SeridiHana,
      description: "Passionnée par la langue française, j’enseigne avec le cœur, pour transmettre non seulement des mots, mais aussi la confiance et le goût d’apprendre.",
      icon: "fas fa-language",
      gradient: gradients[4]
    },
    {
      id: 6,
      name: "Manal HAOUALA",
      role: "EFL Teacher & Voice Actor",
      image: HaoualaManal,
      description: "A passionate English as a Foreign Language teacher and talented voice actor, dedicated to inspiring learners through creativity, expression, and clear communication.",
      icon: "fas fa-globe-europe",
      gradient: gradients[5]
    },
    {
      id: 7,
      name: "Ala KERBOUCHE",
      role: "English Tutor",
      image: AlaKERBOUCHE,
      description: "Holding a Master’s in English Language and Culture, my classes are driven by passion and informed by expertise. With a set of influential soft skills such as public speaking I guide every learner to love the language and thrive with confidence in his journey.",
      icon: "fas fa-child",
      gradient: gradients[6]
    },
    {
      id: 8,
      name: "Fatine Hadil Bouacha",
      role: "English Tutor",
      image: fatinehadilbouacha,
      description: "A caring English teacher with a Master’s degree in English language and culture, dedicated to building students’ confidence and inspiring them to be active learners. My classes are filled with love and support, helping students grow in self-belief and reach fluency in English.",
      icon: "fas fa-laptop",
      gradient: gradients[7]
    },
    {
      id: 9,
      name: "Amel Khalfallah",
      role: "Teacher of English",
      image: AmelKhalfallah,
      description: "Dedicated ESL/EFL educator passionate about creating engaging and interactive lessons. Focused on helping learners build confidence and improve communication through creativity and technology. Experienced in designing materials and activities that make learning practical, enjoyable, and effective for all students.",
      icon: "fas fa-laptop",
      gradient: gradients[0]
    },
    {
      id: 10,
      name: "Belbakhouche Lamis",
      role: "Italian Tutor",
      image: belbakhouchelamis,
      description: "Un’insegnante di italiano appassionata e premurosa, con una profonda conoscenza della lingua e della cultura italiana. Mi dedico ad aiutare gli studenti a sviluppare fiducia in sé stessi e ad amare l’apprendimento. Le mie lezioni sono piene di entusiasmo e sostegno, per guidare ogni studente verso la padronanza e la naturalezza nell’uso dell’italiano.",
      icon: "fas fa-laptop",
      gradient: gradients[1]
    },
    {
      id: 11,
      name: "Bouchemal Souha",
      role: "Administration Staff & Ecology Student",
      image: bouchemalSouha,
      description: "A dedicated administration professional and ecology student who combines organization with  passion to support, learn, and contribute to a more sustainable and efficient future.",
      icon: "fas fa-laptop",
      gradient: gradients[2]
    }
  ];

  const [isPaused, setIsPaused] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState([]);
  const carouselRef = useRef(null);

  // Duplicate the staff array for seamless infinite loop
  const duplicatedStaff = [...staffMembers, ...staffMembers];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.dataset.staffId;
            setVisibleCards(prev => [...prev, parseInt(id)]);
          }
        });
      },
      { threshold: 0.3 }
    );

    const cardElements = document.querySelectorAll('.staff-card');
    cardElements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft -= 400;
      setCurrentIndex(prev => Math.max(0, prev - 1));
    }
  };

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft += 400;
      setCurrentIndex(prev => Math.min(staffMembers.length - 1, prev + 1));
    }
  };

  const getGradientByIndex = (index) => {
    return gradients[index % gradients.length];
  };

  return (
    <section className="section staff-section" id="staff">
      <div className="container">
        <div className="staff-header centered">
          <h2 className="section-title fade-in">Meet Our Expert Team</h2>
          <p className="section-subtitle fade-in">
            Passionate educators and industry professionals dedicated to your learning journey
          </p>
        </div>
        
        <div 
          className="staff-carousel-container"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div 
            ref={carouselRef}
            className={`staff-carousel-track ${isPaused ? 'paused' : ''}`}
          >
            {duplicatedStaff.map((staff, index) => (
              <div 
                key={`${staff.id}-${index}`} 
                className={`staff-card ${visibleCards.includes(staff.id) ? 'visible' : ''}`}
                data-staff-id={staff.id}
                style={{ animationDelay: `${(index % staffMembers.length) * 0.1}s` }}
              >
                <div className="staff-card-inner">
                  {/* Card Background Glow */}
                  <div 
                    className="staff-card-glow"
                    style={{ background: staff.gradient }}
                  ></div>
                  
                  {/* Main Card Content */}
                  <div className="staff-card-content">
                    {/* Image Container with Gradient Overlay */}
                    <div className="staff-image-container">
                      <div 
                        className="staff-gradient-overlay"
                        style={{ background: staff.gradient }}
                      ></div>
                      <img 
                        src={staff.image} 
                        alt={staff.name}
                        className="staff-image"
                        onError={(e) => {
                          // Fallback if local image fails to load
                          e.target.style.display = 'none';
                          e.target.nextElementSibling.style.display = 'block';
                        }}
                      />
                      {/* Fallback if image doesn't exist */}
                      <div 
                        className="staff-image-fallback"
                        style={{ 
                          background: staff.gradient,
                          display: 'none'
                        }}
                      >
                        <i className={staff.icon}></i>
                      </div>
                      <div className="staff-icon-container">
                        <div 
                          className="staff-icon-background"
                          style={{ background: staff.gradient }}
                        ></div>
                        <div className="staff-icon">
                          <i className={staff.icon}></i>
                        </div>
                      </div>
                    </div>

                    {/* Staff Information */}
                    <div className="staff-info">
                      <h3 className="staff-name">{staff.name}</h3>
                      <p 
                        className="staff-role"
                        style={{ 
                          background: staff.gradient,
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text'
                        }}
                      >
                        {staff.role}
                      </p>
                      <p className="staff-description">{staff.description}</p>
                    </div>

                    {/* Stats Badge */}
                    <div className="staff-stats-badge">
                      <div className="staff-exp">5+ Years</div>
                      <div className="staff-exp-label">Experience</div>
                    </div>

                    {/* Hover Effect */}
                    <div 
                      className="staff-hover-effect"
                      style={{ background: staff.gradient }}
                    ></div>

                    {/* Animated Border */}
                    <div className="staff-animated-border"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Enhanced Controls */}
        <div className="staff-controls">
          <button 
            className="staff-control-btn prev" 
            onClick={handlePrev} 
            aria-label="Previous staff"
            style={{ background: gradients[0] }}
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          
          <div className="staff-indicators">
            {staffMembers.map((_, index) => (
              <button
                key={index}
                className={`staff-indicator ${currentIndex === index ? 'active' : ''}`}
                onClick={() => {
                  if (carouselRef.current) {
                    carouselRef.current.scrollLeft = index * 400;
                    setCurrentIndex(index);
                  }
                }}
                aria-label={`Go to staff member ${index + 1}`}
              />
            ))}
          </div>

          <button 
            className="staff-control-btn next" 
            onClick={handleNext} 
            aria-label="Next staff"
            style={{ background: gradients[1] }}
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default StaffCarousel;
/*
import React, { useState, useRef, useEffect } from 'react';
import './StaffCarousel.css';

// Dynamic import approach
const importAll = (r) => r.keys().map(r);
const imageContext = require.context('./images', false, /\.(png|jpe?g|svg)$/);
const imageFiles = importAll(imageContext);

const StaffCarousel = () => {
  const gradients = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
  ];

  const staffMembers = [
    {
      id: 1,
      name: "Mohammed CHAIB",
      role: "Head of Computer Science Department",
      image: imageFiles[0], // First image
      description: "PhD in Linguistics with 15+ years of teaching experience. Fluent in 6 languages and passionate about making language learning accessible to all ages.",
      icon: "fas fa-user-tie",
      gradient: gradients[0]
    },
    {
      id: 2,
      name: "Prof. Ahmed Al-Mansoori",
      role: "Robotics & AI Specialist",
      image: imageFiles[1], // Second image
      description: "Former NASA engineer with expertise in robotics and artificial intelligence. Loves inspiring young minds to build the future.",
      icon: "fas fa-robot",
      gradient: gradients[1]
    },
    // ... rest of your staff members
  ];

  // ... rest of your component code
};
*/